import React from 'react';
import { motion } from 'framer-motion';
export function PainPoints() {
  const painPoints = ['Hinchazón abdominal que aparece sin razón aparente', 'Cansancio constante aunque duermas', 'Digestión pesada después de casi cada comida', 'Niebla mental y dificultad para concentrarte', 'Inflamación silenciosa que sientes pero no logras explicar', 'Incomodidad con tu propio cuerpo', 'Peso que no cede aunque cuides lo que comes', 'Sensación de no entender qué le pasa a tu cuerpo'];
  return <section className="w-full px-4 py-20 bg-ivory" data-id="element-241">
      <div className="max-w-4xl mx-auto" data-id="element-242">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-243">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-ink mb-6" data-id="element-244">
            Si te reconoces en esto, esta guía fue escrita para ti
          </h2>
          <p className="text-lg md:text-xl text-ink/80 max-w-2xl mx-auto leading-relaxed" data-id="element-245">
            Marca con honestidad las señales que tu cuerpo te ha estado
            enviando. Si te identificas con 3 o más… esta guía fue escrita
            exactamente para ti.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6" data-id="element-246">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} className="flex items-start gap-4 p-4 rounded-xl hover:bg-cream transition-colors" data-id="element-247">
              <div className="w-2 h-2 rounded-full bg-clay mt-2.5 shrink-0" data-id="element-248" />
              <p className="text-lg text-ink/90 leading-relaxed" data-id="element-249">{point}</p>
            </motion.div>)}
        </div>

        {/* Mini CTA suave */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="mt-14 text-center" data-id="element-250">
          <p className="inline-block text-base md:text-lg text-clay font-serif italic px-6 py-3 border-t border-b border-clay/20" data-id="element-251">
            👉 Si esto te suena familiar, sigue leyendo. Hay una salida clara.
          </p>
        </motion.div>
      </div>
    </section>;
}